import React, { useState } from 'react'
import MarketSurveyParameterForm from './MarketSurveyParameterForm';
import MarketSurveyParameterList from './MarketSurveyParameterList';

const MarketSurveyParameter= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);
    const [serviceId, setServiceId] = useState("none");

  return (
    <>
      {fromIsShown ? (
          <MarketSurveyParameterForm addForm={setFromIsShown} update={upData} sId={serviceId} />
        ) : (
          <MarketSurveyParameterList addForm={setFromIsShown} update={setUpData} sId={setServiceId} />
        )}
  
    </>
  )
}

export default MarketSurveyParameter;